import ApiClient from "../api/apiClient";

const NEW_APPLICANTS = "/certificates/applicants/";
const NEW_APPLICANTS_ = "/certificates/applicants";
const QUALIFICATION = "/qualifications";
const EXPERIENCES = "/experiences";
const SLOTS = "/slots";
const STATUS_COUNT = "/certificates/get-new-applicant-status-count";
const SCHEDULE_ASSESSMENT = "/certificates/schedule-assessment";
const CHANGE_TECH_FIELD = "/user/application-type";
const INTERVIEW_DETAILS = "/user/get-interview-report";
const STATUS_COUNT_TABS = "/certificates/get-applicant-status-count"

const getNewApplicants = ({
    page,
    limit,
    certificate_type,
    certificate_status,
    start_date,
    end_date,
    full_name,
    registered_from,
    registered_to,
    board_approval_from,
    board_approval_to,
    email,
    filter_status,
    registration_no,
    technology_field,
    identity_number,
    payment_from,
    payment_to,
    search,
    status,
    assessment_from,
    assessment_to,
}) => {
    const baseUrl = `${NEW_APPLICANTS_}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}&certificate_type=${certificate_type}&certificate_status=${certificate_status}`;

    // if (certificate_type === 1 || certificate_type === 2 || status || certificate_type === 5) {
    //     queryParams += `&certificate_status=${certificate_status}`;
    // }

    // Add optional parameters if present
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (email && email !== undefined && email !== "" && email !== null) queryParams += `&email=${email}`;
    if (registration_no) queryParams += `&registration_no=${registration_no}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (assessment_from) queryParams += `&assessment_from=${assessment_from}`;
    if (assessment_to) queryParams += `&assessment_to=${assessment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getNewApplicantsProfileInformation = ({ id }) => {
    const url = NEW_APPLICANTS + id;
    return ApiClient.get(url);
};

const changeApplicantsStatus = (data) => {
    const url = NEW_APPLICANTS + "status";
    return ApiClient.put(url, data);
};

const getInterviewDetails = ({ page,
    limit,
    certificate_type,
    certificate_status,
    start_date,
    end_date,
    full_name,
    interview_date,
    technology_field,
    identity_number,
    search, }) => {
    const baseUrl = `${INTERVIEW_DETAILS}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}`;

    // if (certificate_type === 1 || certificate_type === 2 || status || certificate_type === 5) {
    //     queryParams += `&certificate_status=${certificate_status}`;
    // }

    // Add optional parameters if present
    if (certificate_status) queryParams += `&certificate_status=${certificate_status}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (interview_date) queryParams += `&interview_date=${interview_date}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (search) queryParams += `&search=${search}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getQualificationById = (id) => {
    const url = QUALIFICATION + "/" + id;
    return ApiClient.get(url);
};

const getUserExperienceById = (id) => {
    const url = EXPERIENCES + "/" + id;
    return ApiClient.get(url);
};

const changeStatus = (data) => {
    const url = NEW_APPLICANTS + "status";
    return ApiClient.put(url, data);
};

const availableSlots = (date) => {
    return ApiClient.get(`${SLOTS}?date=${date}`);
};

const assessmentSchedule = (data) => {
    return ApiClient.patch(SCHEDULE_ASSESSMENT, data);
}

const changeUserTechField = (data) => {
    return ApiClient.patch(CHANGE_TECH_FIELD, data);
}

const getApplicantsStatusCount = ({ certificate_type,
    certificate_status,
    start_date,
    end_date,
    full_name,
    registered_from,
    registered_to,
    board_approval_from,
    board_approval_to,
    email,
    filter_status,
    registration_no,
    technology_field,
    identity_number,
    payment_from,
    payment_to,
    search,
    status,
    assessment_from,
    assessment_to }) => {
    const baseUrl = `${STATUS_COUNT}?`;
    let queryParams = "";
    queryParams += `certificate_type=${certificate_type}&certificate_status=${certificate_status}`;

    // if (certificate_type === 1 || certificate_type === 2 || status || certificate_type === 5) {
    //     queryParams += `&certificate_status=${certificate_status}`;
    // }
    // Add optional parameters if present
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (email) queryParams += `&email=${email}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (registration_no) queryParams += `&registration_no=${registration_no}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (assessment_from) queryParams += `&assessment_from=${assessment_from}`;
    if (assessment_to) queryParams += `&assessment_to=${assessment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getApplicantsTabsStatusCount = ({ certificate_type,
    start_date,
    end_date,
    full_name,
    registered_from,
    registered_to,
    board_approval_from,
    board_approval_to,
    email,
    filter_status,
    registration_no,
    technology_field,
    identity_number,
    payment_from,
    payment_to,
    search,
    applicant_status,
    assessment_from,
    assessment_to }) => {
    const baseUrl = `${STATUS_COUNT_TABS}?`;
    let queryParams = "";
    queryParams += `certificate_type=${certificate_type}`;

    // if (certificate_type === 1 || certificate_type === 2 || status || certificate_type === 5) {
    //     queryParams += `&certificate_status=${certificate_status}`;
    // }
    // Add optional parameters if present
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (email) queryParams += `&email=${email}`;
    if (filter_status) queryParams += `&filter_status=${filter_status}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
    if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
    if (registration_no) queryParams += `&registration_no=${registration_no}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (assessment_from) queryParams += `&assessment_from=${assessment_from}`;
    if (assessment_to) queryParams += `&assessment_to=${assessment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (applicant_status) queryParams += `&applicant_status=${applicant_status}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

export const newApplicantsService = {
    getNewApplicants,
    getNewApplicantsProfileInformation,
    changeApplicantsStatus,
    getQualificationById,
    getUserExperienceById,
    changeStatus,
    availableSlots,
    assessmentSchedule,
    getApplicantsStatusCount,
    changeUserTechField,
    getApplicantsTabsStatusCount,
    getInterviewDetails
};
